import * as React from 'react';
import { useEffect, useState } from 'react';
import authService from './api-authorization/AuthorizeService';
import { NavLink, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import useAppRoutes from '../AppRoutes';

const BeheerMenu = () => {

	//let _subscription: number | undefined;
	const routePaths = useAppRoutes();
	const [isAuthenticated, setIsAuthenticatded] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	//const [mfaEnabled, setMfaEnabled] = useState(false);
	//const [profile, setProfile] = useState<OAuthProfile>();

	useEffect(() => {
		authService.getUser().then(p => {
			setIsAdmin(p?.Role === "Beheerder");
		//	setMfaEnabled(p?.amr?.includes("mfa") || false)
		})
	}, [])

	useEffect(() => {
		const _subscription = authService.subscribe(populateState);
		populateState();
		return () => authService.unsubscribe(_subscription);
	}, []);

	const populateState = async () => {
		const result = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
		setIsAuthenticatded(result[0] || false);
		//setProfile(result[1]);
	}

	if (!isAuthenticated) // || !mfaEnabled)
		return null;

	return <UncontrolledDropdown nav inNavbar>
		<DropdownToggle nav caret>Instellingen</DropdownToggle>
		<DropdownMenu right>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.goedePraktijken}>Goede praktijken
				</NavLink>
			</DropdownItem>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.visitatieRapporten}>Visitatierapporten
				</NavLink>
			</DropdownItem>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.documenten}>Documenten
				</NavLink>
			</DropdownItem>
			<DropdownItem divider />
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.gemeenten}>Gemeenten
				</NavLink>
			</DropdownItem>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.operationeleDoelstellingen}>Operationele doelstellingen
				</NavLink>
			</DropdownItem>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.shms}>Shm's
				</NavLink>
			</DropdownItem>
			<DropdownItem>
				<NavLink
					tag={RRNavLink}
					activeClassName="active"
					exact to={routePaths.themas}>Thema's
				</NavLink>
			</DropdownItem>

			{isAdmin && <>			
				<DropdownItem divider />
				<DropdownItem>
					<NavLink
						tag={RRNavLink}
						activeClassName="active"
						exact to={routePaths.gebruikers}>Gebruikers
					</NavLink>
				</DropdownItem>
			</>}

		</DropdownMenu>
	</UncontrolledDropdown>

}
export default BeheerMenu;